import { useEffect, useState } from 'react'

const formatTime = (timeZone: string): string => {
    try {
        return new Intl.DateTimeFormat('en-GB', {
            timeZone,
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        }).format(new Date())
    } catch {
        // Invalid / unknown IANA timezone — render nothing rather than crash.
        return ''
    }
}

export interface PortalLocalTimeProps {
    timezone: string
    className?: string
}

/** Live local time for an IANA timezone, e.g. "18:28". Re-renders each minute. */
export const PortalLocalTime = ({ timezone, className }: PortalLocalTimeProps) => {
    const [time, setTime] = useState(() => formatTime(timezone))

    useEffect(() => {
        setTime(formatTime(timezone))
        const id = setInterval(() => setTime(formatTime(timezone)), 60_000)
        return () => clearInterval(id)
    }, [timezone])

    if (!time) return null
    return <span className={className}>{time}</span>
}
